// apiThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const catchmentJourneyGetData = createAsyncThunk(
  "catchmentData/catchmentJourneyGetData",
  async (thingId, { getState, rejectWithValue }) => {
    console.log("Thunk started...");

    const state = getState();
    const sessionToken = localStorage.getItem("token");

    if (!sessionToken) {
      return rejectWithValue("Session expired. Please login again.");
    }

    try {
      const response = await axios.get(
        `https://v3.dhundhoo.com/reports/catchmentReport/${thingId}`,
        {
          headers: {
            "x-dhundhoo-session": sessionToken,
          },
          params: {
            thingId: thingId,
          },
        }
      );

      return {
        data: response.data,
        message: "Catchment report fetched successfully",
      };

    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong while fetching report"
      );
    }
  }
);